import { render, staticRenderFns } from "./ppa-quote.vue?vue&type=template&id=bccc2c3c&scoped=true"
import script from "./ppa-quote.vue?vue&type=script&lang=js"
export * from "./ppa-quote.vue?vue&type=script&lang=js"
import style0 from "./ppa-quote.vue?vue&type=style&index=0&id=bccc2c3c&prod&scoped=true&lang=css"
import style1 from "./ppa-quote.vue?vue&type=style&index=1&id=bccc2c3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccc2c3c",
  null
  
)

export default component.exports